/* eslint-disable import/no-default-export */
export default {
  hireFormRequested12HoursAgo: 'Requested 12 Hrs Ago',
  hireFormRequested24HoursAgo: 'Requested 24 Hrs Ago',
  hireFormRequested48HoursAgo: 'Requested 48 Hrs Ago',
  hireFormRequested72HoursAgo: 'Requested 72 Hrs Ago',
  hireFormCompleted24HoursAgo: 'Completed 24 Hrs Ago',
  hireFormHelpRequested: 'Help Requested',
  hireFormInReview: 'Resubmission Requested',

  hireFormResubmission12HoursAgo: 'Hire Form Resubmission Requested 12 Hrs Ago',
  hireFormResubmission24HoursAgo: 'Hire Form Resubmission Requested 24 Hrs Ago',
  hireFormResubmission48HoursAgo: 'Hire Form Resubmission Requested 48 Hrs Agoo',
  hireFormResubmission72HoursAgo: 'Hire Form Resubmission Requested 72 Hrs Ago',

  bgCheckRequested24HoursAgo: 'Requested 24 Hrs Ago',
  bgCheckRequested48HoursAgo: 'Requested 48 Hrs Ago',
  bgCheckRequested72HoursAgo: 'Requested 78 Hrs Ago',
  bgCheckFlaggedByCertnCandidates: 'Flagged By Background Check',
  bgCheckCleared: 'Completed Background Check',
  bgCheckNotProcessedByCertn24HoursAgoCandidates: 'Not Yet Processed ',

  offerMade12HoursAgo: 'Offer Made 12 Hrs Ago',
  offerMade24HoursAgo: 'Offer Made 24 Hrs Ago',
  offerMade36HoursAgo: 'Offer Made 36 Hrs Ago',
  offerMade48HoursAgo: 'Offer Made 48 Hrs Ago',

  offerAccepted12HoursAgo: 'Offer Accepted 12 Hrs Ago',
  offerAccepted24HoursAgo: 'Offer Accepted 24 Hrs Ago',
  offerAccepted36HoursAgo: 'Offer Accepted 36 Hrs Ago',
  offerAccepted48HoursAgo: 'Offer Accepted 48 Hrs Ago',

  i9Verification: 'I-9 Verification',
  workbrightRequested24HoursAgo: 'Requested 24 Hrs Ago',
  workbrightRequested36HoursAgo: 'Requested 36 Hrs Ago',
  workbrightRequested48HoursAgo: 'Requested 48 Hrs Ago',
  workbrightRequested60HoursAgo: 'Requested 60 Hrs Ago',
  workbrightRequested72HoursAgo: 'Requested 72 Hrs Ago',
  workbrightCompleted: 'Submitted',
  workbrightDeclined: 'Rejected',
  workbrightAccepted: 'Approved',

  offerRejected: 'Offer Rejected',
  offerExpired: 'Offer Expired',
  offerRejected12HoursAgo: 'Rejected 12 Hrs Ago',
  offerRejected24HoursAgo: 'Rejected 24 Hrs Ago',
  offerRejected36HoursAgo: 'Rejected 36 Hrs Ago',
  offerRejected48HoursAgo: 'Rejected 48 Hrs Ago',
  offerExpired12HoursAgo: 'Expired 12 Hrs Ago',
  offerExpired24HoursAgo: 'Expired 24 Hrs Ago',
  offerExpired36HoursAgo: 'Expired 36 Hrs Ago',
  offerExpired48HoursAgo: 'Expired 48 Hrs Ago',

  reviewPausedQuestionAnswer: 'Review Paused Question Answer',
  todoTableLoaderText: 'We’re getting your tasks ready…',

  summary: 'Summary',
  hiresProcessing: 'Hires In Process',
  outstandingOffers: 'Outstanding Offers',
  toDo: 'To Do',
  inProgress: 'In Progress',
  completed: 'Completed',
  hireForm: 'Hire Form',
  backgroundCheck: 'Background Check',
  offer: 'Offer',
  languageEvaluation: 'Language Evaluation',
  conversationalAI: 'Conversational AI',
  dialogflow: 'Conversational AI',
  filterBy: 'Filter By',
  pausedCandidates: 'Paused Candidates',
  upcomingInterviews: 'Scheduled Interviews',
  coInterviewer: 'Co-interviewers:',
  interviewTime: ' at {{time}}',
  isOngoing: 'Ongoing ',
  isUpcoming: 'Upcoming ',
  collaboratorCount: '+ {{count}} more',

  pageTitle: 'Today’s To Do List',

  actionToTake: 'To Do',
  lastStatus: 'Last Update',
  status: 'Status',
  locationAndPosition: 'Location & Position',
  candidate: 'Candidate',
  hrPlus: 'h +',
  noData: 'No Data Found',
  hi: 'Hey',
  cancel: 'Cancel',
  sendEmail: 'Send Email',
  send: 'Send',
  review: 'Review',
  sendAndDismissed: 'Send and Dismiss candidate',
  sending: 'Sending',
  contactCertn: 'Contact Certn',
  contactDollarama: 'Contact Dollarama',
  contactMoss: 'Contact Your Administrator',
  dismissedCandidateTitle: 'Dismiss Candidate',
  offerTitle: 'Pending Offer',
  offerMade12HoursAgoDesp: 'Offer made over 12 hours ago. Message candidate, informing them they need to respond to the offer.',
  offerMade24HoursAgoDesp:
    'Offer made over 24 hours ago. Message candidate, informing them they need to respond to the offer. Warn them they may be removed from the process if they do not accept or decline the offer.',
  offerMade36HoursAgoDesp: 'Offer made over 36 hours ago. Message candidate, informing them they need to respond to the offer.',
  offerMade48HoursAgoDesp:
    'Offer made over 48 hours ago. Final attempt: Call candidate by phone, then send a message to inform them that they will be removed from the process tonight unless they accept the offer.',
  hireFormTitle: 'Pending Hire Form Completion',
  hireFormResubmissionTitle: 'Pending Hire Form Resubmission Completion',
  hireFormRequested12HoursAgoDesp: -'Hire form requested over 12 hours ago. Message candidate, asking them to complete hire form as the last step in the hiring process.',
  hireFormRequested24HoursAgoDesp: 'Hire form requested over 24 hours ago. Message candidate, to complete hire form.',
  hireFormRequested48HoursAgoDesp:
    'Hire form requested over 48 hours ago. Final attempt: Call candidate by phone, then message them so they are aware that they will be removed from the process if this is not completed within 12 hours .',
  hireFormRequested60HoursAgoDesp:
    'Hire form requested over 60 hours ago. Dismiss candidate unless sufficient justification for the delay has been given. Review daily and dismiss if appropriate.',
  hireFormRequested72HoursAgoDesp:
    'Hire form requested over 60 hours ago. Dismiss candidate unless sufficient justification for the delay has been given. Review daily and dismiss if appropriate.',

  hireFormResubmission12HoursAgoDesp: -'Hire form resubmission over 12 hours ago. Message candidate, asking them to complete hire form as the last step in the hiring process.',
  hireFormResubmission24HoursAgoDesp: 'Hire form resubmission over 24 hours ago. Message candidate, to complete hire form.',
  hireFormResubmission48HoursAgoDesp:
    'Hire form resubmission over 48 hours ago. Final attempt: Call candidate by phone, then message them so they are aware that they will be removed from the process if this is not completed within 12 hours .',
  hireFormResubmission60HoursAgoDesp:
    'Hire form resubmission over 60 hours ago. Dismiss candidate unless sufficient justification for the delay has been given. Review daily and dismiss if appropriate.',
  hireFormResubmission72HoursAgoDesp:
    'Hire form resubmission over 60 hours ago. Dismiss candidate unless sufficient justification for the delay has been given. Review daily and dismiss if appropriate.',

  backgroundCheckTitle: 'Pending Background Check Completion',
  bgCheckRequested12HoursAgoDesp: 'Background check requested over 12 hours ago. Chase candidate to complete the process.',
  bgCheckRequested24HoursAgoDesp:
    'Background check requested over 24 hours ago. Warn candidate they may be removed from the process.',
  bgCheckRequested36HoursAgoDesp:
    'Background check requested over 36 hours ago. Message candidate to inform them they are being removed from the process and dismiss them.',
  bgCheckRequested48HoursAgoDesp:
    'Background check requested over 48 hours ago. Message candidate to inform them they are being removed from the process and dismiss them.',
  bgCheckFlaggedByCertnCandidatesDesp: 'Background check has been flagged by provider. Review the background check results.',
  bgCheckRequested72HoursAgoDesp:
    'Background check requested over 72 hours ago. Message candidate to inform them they are being removed from the process and dismiss them.',
  bgCheckNotProcessedByCertn24HoursAgoCandidatesDesp: `Background check still being analyzed by Certn 24 hours after submission. Contact Certn at <a href="mailto:support@certn.co" target='_blank'>support@certn.co</a> to request update`,
  hireFormCompleted24HoursAgoDesp: `Contact payroll@dollarama.com and CC appyhere@dollarama.com to get an update on the completed hire form still pending verification. Important: only submit if the candidate's earliest start date is planned for this week.`,
  hireFormCompletedNonReq: `You must contact your administrator to get more details on why the form is still pending approval.`, // added for Non req account
  hireForHelpRequestTitle: 'Hire Form Help Requested',
  hireFormHelpRequestDesp:
    'Candidate has requested assistance in completing their Hire Form. Message candidate to investigate their issue.',
  helpRequestFor: 'Candidate stuck on {{feildName}} step',
  yourReply: 'Your Reply',
  sendMessage: 'Send Message',
  enterYourMessage: 'Enter your message',
  showingResult: 'Showing {{currentItemsLength}} of {{totalItemsLength}} tasks',
  urlCopiedInfo: 'Copied Candidate URL',
  hireFormId: 'Hire Form ID:',
  hireDetailIdCopiedInfo: 'Copied Hire Form ID',
  mailtoHireForm: 'Hire%20form%20overdue%20for%20Hire%20ID:%20',
  showCompletedItems: 'Show Completed Tasks',
  allCaughtUp: `You're All Caught Up!`,
  noPendingUpdates: 'There are no pending actions at the moment.',
  checkBackLater: 'Check back frequently to see if anything needs your attention.',
  inProgressForMe: 'In Progress (for me)',
  inProgressForOthers: 'In Progress (for others)',
  selectAll: 'Select All',
  i9CheckRequestTitle: 'Remind Candidate To Complete Their I-9 Form',
  i9Requested24HrsAgoDesp:
    'I-9 form requested over 24 hours ago. Message the candidate, informing them they need to complete their I-9 form.',
  i9Requested36HrsAgoDesp:
    'I-9 form requested over 36 hours ago. Message the candidate, informing them they need to complete their I-9 form.',
  i9Requested48HrsAgoDesp: `I-9 form requested over 48 hours ago. Message the candidate, informing them they need to complete their I-9 form.`,
  i9Requested60HrsAgoDesp: `I-9 form requested over 60 hours ago. Message the candidate, informing them that they will be removed from the process if they do not complete their I-9 form on time.`,
  i9Requested72HrsAgoDesp: `I-9 form requested over 72 hours ago. Message the candidate, informing them that they will be removed from the process if they do not complete their I-9 form on time.`,
  i9RejectTitle: 'Remind Candidate To Correct Their I-9 Details',
  i9RejectDesp: `The candidate's I-9 form was rejected. Message the candidate, informing them they need to correct information in their I-9 form.`,
  reason: 'Reason:',
  errorMsg: 'This candidate is no longer looking for work.',
};
